import axios from 'axios';

export default async function createLocationGroupInvite({
  accessToken,
  email,
  location_group_id,
  created_by = 1,
  isLoading,
}) {
  try {
    console.log('createLocationGroupInvite');
    console.log({
      accessToken,
      email,
      location_group_id,
      created_by,
      isLoading,
    });

    if (isLoading) isLoading(true);

    const requestOptions = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const { data } = await axios.post(
      `${process.env.REACT_APP_INVITES_API_URL}/location-group`,
      {
        email, location_group_id, created_by,
      },
      requestOptions,
    );

    return data;
  } catch (err) {
    return null;
  } finally {
    if (isLoading) isLoading(false);
  }
}
